<!--
<div class="container">
  <h5 class="text-center mt-3">Logging SMS</h5>
  <div class="d-flex my-2 align-content-center justify-content-center" >
    <div class="input-field" >
      <input class="mat-form-field custom-i" type="text" placeholder="Rechercher ici ...." #searchBox (keyup)="search(searchBox.value) ">

    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-bordered p-0 m-0">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Télephone</th>
        <th scope="col">Transaction / USSD ID</th>
        <th scope="col">Message</th>
        <th scope="col">Source</th>
        <th scope="col">Status</th>
        <th scope="col">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr scope="row" *ngFor="let sms of auditSms">
        <td>{{ sms?.id }}</td>
        <td>{{ sms?.receivedPhoneNumber }}</td>
        <td>{{ sms?.transactionId ? sms?.transactionId : sms?.ussdSessionId }}</td>
        <td>{{ sms?.contentSms}}</td>
        <td>{{ sms?.provider }}</td>
        <td>{{ sms?.status }}</td>
        <td></td>
    </tr>
      </tbody>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" [length]="totalElements" (page)="nextPage($event)"> </mat-paginator>
  </div>
</div>
-->


<mat-card class="mat-elevation-z8">
  <h5 class="text-center mt-3">Logging SMS</h5>
  <div class="row">
    <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 "
                    style="margin-left: auto; margin-right: auto;margin-top: 20px">
      <input  (keyup)="applyFilter($event)"  aria-label="Rechercher dans les audits" matInput #input

              placeholder="Rechercher dans les audits" [formControl]="searchControl" [(ngModel)]="search">
    </mat-form-field>
  </div>
  <!--<mat-form-field>
    <mat-label>Recherche</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. 22966895585" #input>
  </mat-form-field>-->

  <!-- Mat Spinner-->
  <div *ngIf="loading" class="loading-shade">
    <mat-spinner *ngIf="loading"></mat-spinner>
  </div>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <!-- ID Column
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
        <td mat-cell *matCellDef="let row"> {{row.id}} </td>
      </ng-container>-->

      <!-- Progress Column -->
      <ng-container matColumnDef="provider">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Source</th>
        <td mat-cell *matCellDef="let row"> {{row.provider}}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="receivedPhoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Telephone</th>
        <td mat-cell *matCellDef="let row"> {{row.receivedPhoneNumber}} </td>
      </ng-container>

      <!-- Fruit Column -->
      <ng-container matColumnDef="contentSms">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Contenus</th>
        <td mat-cell *matCellDef="let row"> {{row.contentSms}} </td>
      </ng-container>

      <!-- Fruit Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
        <td mat-cell *matCellDef="let row"> {{row.status}} </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> ACTIONS </th>
        <td mat-cell *matCellDef="let row">
          <button  (click)="resentSms(row?.transactionId ? row?.transactionId : row?.ussdSessionId )" mat-button >
            Renvoyer SMS
            <mat-icon>send</mat-icon>
          </button>
        </td>
      </ng-container>


      <ng-container matColumnDef="transactionId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Id</th>
        <td mat-cell *matCellDef="let row"> {{ row?.transactionId ? row?.transactionId : row?.ussdSessionId }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Pas de données pour ce filtre "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator *ngIf="auditsPage.totalElements>10" [length]="auditsPage.totalElements" [pageSizeOptions]="[10, 20, 50, 100]"
                   [pageSize]="auditsPage.size"
                   (page)="setPage($event)" [showFirstLastButtons]="true"
                   aria-label="Sélectionnez une page" >
    </mat-paginator>

  </div>
</mat-card>
